export default "__VITE_ASSET__SrQ3ADtS__"